module.exports = __webpack_public_path__ + "static/media/1018075.a6d86c08.png";